export default "__VITE_ASSET__CazsgSoM__"